import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MainProjectTabs } from '../../enum';
import { NavigationBase } from '../../navigation-base';
import { NavigationService } from '../../navigation.service';
import { EventBusService } from '../../../services/event-bus.service';

/**
 * Navigation for the /mp area
 */
@Component({
  selector: 'project-main-navigation',
  templateUrl: './project-main-navigation.component.html'
})
export class ProjectMainNavigationComponent extends NavigationBase implements OnInit {
  /**
   * ChangeDetectorRef
   */
  _ref: ChangeDetectorRef

  /**
   * Constructor
   * @param ref ChangeDetectorRef
   * @param navigationService NavigationService
   */
  constructor(eventBus: EventBusService, ref: ChangeDetectorRef, private navigationService: NavigationService) {
    super(eventBus, ref);
    this._ref = ref;
  }

  /**
   * The selected tab
   */
  selectedTab: MainProjectTabs = MainProjectTabs.Projects;

  /**
   * Search tab visible?
   */
  searchTabVisible = false;

  /**
   * Search mode: Which BO?
   */
  searchMode = 'projectstd';

  /**
   * REM inactive?
   */
  remInactive = false;

  /**
   * REM BC inactive?
   */
  remBcInactive = false;

  /**
   * Valuation portfolios inactive?
   */
  valuationInactive = false;

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    super.ngOnInit();
    this.handleNavigationState();
    this.subscribeToActiveTab();
  }

  /**
   * Subscribe to the active tab selection
   */
  subscribeToActiveTab() {
    this.subscriptions.add(this.navigationService.activeMainProjectTab$.subscribe((tab: MainProjectTabs) => {
      this.selectedTab = tab;
      this._ref.markForCheck();
    }))
  }

  /**
   * Handles the navigation state. Enables/disables tabs
   */
  handleNavigationState() {
    this.onEvents.push(this.eventBus.subscribeEvent('setCounterValueBroadcast', (tab, value) => {
      const counterIsZero = value <= 0;
      switch (tab) {
        case 'rem':
          this.remInactive = counterIsZero;
          break;
        case 'valuationPortfolio':
          this.valuationInactive = counterIsZero;
          break;
        case 'remBC':
          this.remBcInactive = counterIsZero;
          break;
        default:
          return;//not our tab
      }

      this._ref.markForCheck();
    }));
  }

  /**
   * Rediretcs to the selected tab
   * @param tab The desired tab
   */
  redirectTo(tab: string) {
    this.setSelectedTab(tab);
    this.eventBus.broadcastEvent('projectMainTabSelect', tab);
    this.eventBus.broadcastEvent('searchBarVisibility', false, '');
    this.searchTabVisible = false;
  }

  /**
   * Gets the MainProjectTabs enum
   */
  public get activeTab(): typeof MainProjectTabs {
    return MainProjectTabs;
  }

  /**
   * Sets the selected tab
   * @param tab The selected tab
   */
  private setSelectedTab(tab: string) {
    switch (tab) {
      case 'tabProjectstd':
        this.selectedTab = MainProjectTabs.Projects;
        this.searchMode = 'projectstd'
        break;
      case 'tabValuationPortfolio':
        this.selectedTab = MainProjectTabs.ValPortofolios;
        this.searchMode = 'report'
        break;
      case 'tabREM':
        this.selectedTab = MainProjectTabs.RiskEChecklist;
        this.searchMode = 'valuationPortfolio'
        break;
      case 'tabREMBC':
        this.selectedTab = MainProjectTabs.EmaeBusinessCase;
        break;
    }

    this.navigationService.setActiveMainProjectsTab(this.selectedTab);
  }

  /**
   * Sets the search bar visibility
   */
  setSearchBarVisibility() {
    this.searchTabVisible = !this.searchTabVisible;
    this.eventBus.broadcastEvent('searchBarVisibility', this.searchTabVisible, this.searchMode);
  }
}
